import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { useBffClient } from './client';
import type { EventTimeline, EventTrends, DetectionHistoryPage } from '../types/event';

export function useEventTimeline(from: string, to: string, granularity = 'hour') {
  const client = useBffClient();
  return useQuery({
    queryKey: ['events', 'timeline', from, to, granularity],
    queryFn: () =>
      client.get<EventTimeline>(
        `/bff/events/timeline?from=${from}&to=${to}&granularity=${granularity}`,
      ),
    enabled: !!from && !!to,
  });
}

export function useEventTrends(daysBack = 7) {
  const client = useBffClient();
  return useQuery({
    queryKey: ['events', 'trends', daysBack],
    queryFn: () => client.get<EventTrends>(`/bff/events/trends?daysBack=${daysBack}`),
  });
}

export function useEventHistory(category?: string) {
  const client = useBffClient();
  return useInfiniteQuery({
    queryKey: ['events', 'history', category],
    queryFn: async ({ pageParam }) => {
      let url = `/bff/events/history?limit=50`;
      if (pageParam) url += `&cursor=${encodeURIComponent(pageParam)}`;
      if (category) url += `&category=${encodeURIComponent(category)}`;
      return client.get<DetectionHistoryPage>(url);
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  });
}
